import React, { useState } from 'react';
import axios from 'axios';

const DailyCommentEdit = ({ initialEmoji = "", initialComment = "", memberId, currentUserId }) => {
  const [dailyEmoji, setDailyEmoji] = useState(initialEmoji);
  const [dailyComment, setDailyComment] = useState(initialComment);
  const [isLoading, setIsLoading] = useState(false);
  
  const handleSave = () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('profile[daily_emoji]', dailyEmoji);
    formData.append('profile[daily_comment]', dailyComment);

    axios
      .post(`/api/profile/update`, formData)
      .then(() => {
        alert('一言コメントが保存されました！');
        window.location.href = `/member/profile/${memberId}`;
      })
      .catch((error) => {
        console.error('Error saving daily comment:', error);
        alert('保存に失敗しました');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div
      className="daily-comment-container position-relative d-flex align-items-center justify-content-between"
      style={{
        backgroundColor: "#f9f9f9",
        border: "1px solid #e0e0e0",
        borderRadius: "20px",
        padding: "8px 14px",
        width: "100%",
        margin: "20px auto",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* 吹き出し型デザインの三角形部分 */}
      <div
        style={{
          position: "absolute",
          top: "-10px",
          left: "20px",
          width: "20px",
          height: "20px",
          backgroundColor: "#f9f9f9",
          border: "1px solid #e0e0e0",
          transform: "rotate(45deg)",
          overflow: "hidden",
          clipPath: "polygon(0 0, 100% 0, 0 100%)",
        }}
      ></div>

      {/* 絵文字選択 */}
      <div className="d-flex align-items-center">
        {memberId === currentUserId ? (
          <select
            id="emojiDropdown"
            className="form-control"
            style={{ width: "60px", padding: "0" }}
            value={dailyEmoji}
            onChange={(e) => setDailyEmoji(e.target.value)}
          >
            {["", "😊", "😎", "😢", "😡", "😍"].map((emoji) => (
              <option key={emoji} value={emoji}>
                {emoji}
              </option>
            ))}
          </select>
        ) : (
          <span className="display-emoji">{dailyEmoji}</span>
        )}
      </div>

      {/* 一言コメント入力 */}
      <div className="flex-grow-1 mx-2">
        {memberId === currentUserId ? (
          <textarea
            id="dailyComment"
            className="form-control"
            rows="1"
            style={{
              resize: "none",
              height: "40px",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
            value={dailyComment}
            onChange={(e) => setDailyComment(e.target.value)}
          />
        ) : (
          <p 
            className="m-0"
            style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >{dailyComment}</p>
        )}
      </div>

      {/* 保存ボタン */}
      {memberId === currentUserId && (
        <div>
          {isLoading ? (
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <button
              onClick={handleSave}
              className="btn"
              style={{
                padding: "8px 6px",
                backgroundColor: "#FF4D5B",
                color: "white",
                borderRadius: "10px",
                fontSize: "14px",
                whiteSpace: "nowrap"
              }}
            >
              保存
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default DailyCommentEdit;
